import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnersService } from './partners.service';

@NgModule({
  imports: [CommonModule],
  providers: [PartnersService],
})
export class PartnersModule {}
